import { BUFFER_LENGTH } from './constants'
import type { Palette } from './palette'

export const createPlotBuffer = (): Uint8Array => new Uint8Array(BUFFER_LENGTH)

/** Expands a palette-index buffer into opaque RGBA bytes, ready for an ImageData. */
export const bufferToRgba = (
  buffer: Uint8Array,
  palette: Palette,
  out: Uint8ClampedArray,
): Uint8ClampedArray => {
  if (buffer.length !== BUFFER_LENGTH || out.length !== BUFFER_LENGTH * 4) {
    throw new Error(
      `expected a ${BUFFER_LENGTH} byte buffer and a ${BUFFER_LENGTH * 4} byte output`,
    )
  }
  for (let i = 0; i < BUFFER_LENGTH; i++) {
    const [r, g, b] = palette[(buffer[i] ?? 0) & 15] ?? [0, 0, 0]
    const o = i * 4
    out[o] = r
    out[o + 1] = g
    out[o + 2] = b
    out[o + 3] = 255
  }
  return out
}
